(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emoshies-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.emReviewReady === "1") return;
    root.dataset.emReviewReady = "1";
    const viewport = root.querySelector("[data-em-review-viewport]");
    const cards = Array.from(root.querySelectorAll("[data-em-review-card]"));
    const counter = root.querySelector("[data-em-review-counter]");
    const pauseButton = root.querySelector("[data-em-review-pause]");
    if(!viewport || cards.length < 2) return;
    let i=0, manualPause=false, hovered=false, focus=false;
    const reduced=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const visible=()=>window.innerWidth>1100?3:window.innerWidth>=750?2:1;
    const max=()=>Math.max(0,cards.length-visible());
    function go(step){
      i=i+step;
      if(i>max())i=0;
      if(i<0)i=max();
      viewport.scrollTo({left:cards[i].offsetLeft-cards[0].offsetLeft,behavior:reduced?"instant":"smooth"});
      if(counter)counter.textContent=(i+1)+" of "+cards.length;
    }
    root.querySelector("[data-em-review-next]")?.addEventListener("click",()=>go(1));
    root.querySelector("[data-em-review-previous]")?.addEventListener("click",()=>go(-1));
    pauseButton?.addEventListener("click",()=>{
      manualPause=!manualPause;
      pauseButton.textContent=manualPause?"Play":"Pause";
      pauseButton.setAttribute("aria-pressed",String(manualPause));
      pauseButton.setAttribute("aria-label",manualPause?"Resume review carousel":"Pause review carousel");
    });
    root.addEventListener("mouseenter",()=>{hovered=true});
    root.addEventListener("mouseleave",()=>{hovered=false});
    root.addEventListener("focusin",()=>{focus=true});
    root.addEventListener("focusout",()=>{focus=root.contains(document.activeElement)});
    viewport.addEventListener("scroll",()=>{
      const step=cards[1].offsetLeft-cards[0].offsetLeft;
      if(step){i=Math.min(max(),Math.max(0,Math.round(viewport.scrollLeft/step)));if(counter)counter.textContent=(i+1)+" of "+cards.length;}
    },{passive:true});
    if(root.dataset.autoplay==="true"&&!reduced){
      const timer=setInterval(()=>{
        if(!root.isConnected){clearInterval(timer);return}
        if(document.hidden||manualPause||hovered||focus||window.Shopify?.designMode)return;
        go(1);
      },Math.max(3000,Number(root.dataset.interval)||5000));
    }
  }
  function start(scope){(scope||document).querySelectorAll("[data-em-review-section]").forEach(init)}
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",()=>start(document))}else{start(document)}
  document.addEventListener("shopify:section:load",e=>start(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
